import borderBottomDottedModule from './BorderBottomDotted.module.scss';
import PropTypes from 'prop-types';

const BorderBottomDotted = ({ className }) => {
  return (
    <p
      className={`${className} ${borderBottomDottedModule['border-bottom-dotted__border']}`}
      data-testid="border-bottom-dotted"
    ></p>
  );
};
BorderBottomDotted.propTypes = {
  className: PropTypes.string
};
export default BorderBottomDotted;
